import { render, staticRenderFns } from "./RecentArticles.vue?vue&type=template&id=3d56e89c&scoped=true"
import script from "./RecentArticles.vue?vue&type=script&lang=js"
export * from "./RecentArticles.vue?vue&type=script&lang=js"
import style0 from "./RecentArticles.vue?vue&type=style&index=0&id=3d56e89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d56e89c",
  null
  
)

export default component.exports